import React, { useContext, useEffect, useState } from 'react'
import Rotas from './routes'
import theme from './theme/Default'
import { ThemeProvider } from '@mui/material/styles'
import { ToastContainer } from 'react-toastify'
import './global.css'
import 'react-toastify/dist/ReactToastify.css'
import { ReactKeycloakProvider } from '@react-keycloak/web'
import keycloack from './keycloak'
import { BrowserRouter, useLocation, useNavigate } from 'react-router-dom'
import RequireAuth from './services/token'
import {
  PermissionsContext,
  PermissionsProvider
} from './providers/permissions'
import BaseLayout from './layout'
import rotas from './services/rotas'

// Mantém a URL sincronizada com o estado de permissões: navega para a
// página de erro dedicada quando a busca de permissões falha, e volta
// para a home quando o erro é resolvido (ex: "Tentar novamente" funcionou).
function PermissionsErrorWatcher() {
  const { permissionsError } = useContext(PermissionsContext)
  const navigate = useNavigate()
  const location = useLocation()

  useEffect(() => {
    const onErrorPage = location.pathname === rotas.erroPermissoes

    if (permissionsError && !onErrorPage) {
      navigate(rotas.erroPermissoes, { replace: true })
    }
    if (!permissionsError && onErrorPage) {
      navigate(rotas.home, { replace: true })
    }
  }, [permissionsError, location.pathname, navigate])

  return null
}

function AppContent() {
  return (
    <>
      <PermissionsErrorWatcher />
      <BaseLayout>
        <Rotas />
      </BaseLayout>
    </>
  )
}

function App() {
  const [token, setToken] = useState(null)

  return (
    <>
      <ReactKeycloakProvider
        authClient={keycloack}
        onTokens={({ token }) => {
          setToken(token)
        }}
        initOptions={{
          checkLoginIframe: false,
          onLoad: 'login-required'
        }}
      >
        <PermissionsProvider>
          <RequireAuth token={token} />

          <BrowserRouter>
            <div className="App">
              <ToastContainer limit={1} />
              <ThemeProvider theme={theme}>
                <AppContent />
              </ThemeProvider>
            </div>
          </BrowserRouter>
        </PermissionsProvider>
      </ReactKeycloakProvider>
    </>
  )
}

export default App
